export default __webpack_public_path__ + "static/media/datacamp.4126ac64.svg";